import { Link, useLocation } from 'react-router-dom';
import LogoMark from '@/components/LogoMark';

const Navigation = () => {
  const location = useLocation();
  const isLegalPage = location.pathname === '/legal-ai';

  return (
    <nav
      data-testid="main-navigation"
      className="fixed top-0 left-0 right-0 z-50 px-6 md:px-12 py-5 flex items-center justify-between"
      style={{ backgroundColor: 'rgba(58, 61, 66, 0.95)', backdropFilter: 'blur(8px)' }}
    >
      <Link to="/" data-testid="nav-logo" aria-label="Soundboard.space home">
        <LogoMark height={18} />
      </Link>

      <div className="flex items-center gap-6 md:gap-8">
        <a
          href={isLegalPage ? '/#work-with-me' : '#work-with-me'}
          data-testid="nav-work-with-me"
          className="nav-link"
        >
          Work With Me
        </a>
        <Link
          to="/legal-ai"
          data-testid="nav-legal-ai"
          className={`nav-link ${isLegalPage ? 'nav-link-active' : ''}`}
        >
          Legal AI
        </Link>
      </div>
    </nav>
  );
};

export default Navigation;
